import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CORE_CONFIG_TOKEN } from '@ndk/ng-core/component/core.config';
import { Observable } from 'rxjs';

import { ICoreConfigInternal } from '@core/core.config.model';

@Injectable()
export class PartnerParametersService {

    private apiUrl: string;

    constructor(
        @Inject(CORE_CONFIG_TOKEN) config: ICoreConfigInternal,
        private http: HttpClient,
    ) {
        this.apiUrl = `${ config.apiEndpoint }api/partner-parameters`;
    }

    public checkUserPermissionToScanFlowManagement(): Observable<boolean> {
        return this.http.get<boolean>(`${ this.apiUrl }/scan-flow-permission`);
    }

    public checkUserPermissionToSaveTonerLicensingManagement(): Observable<boolean> {
        return this.http.get<boolean>(`${ this.apiUrl }/save-toner-licensing-permission`);
    }
}
